import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

/** Renderiza inputs adicionales cuando la clinica los marco como obligatorios
 * en Configuracion (email siempre se muestra aparte en cada formulario). */
export default function RequiredPatientFieldsFields({ requiredFields, form, setForm, testIds }) {
  return (
    <>
      {requiredFields.includes("date_of_birth") && (
        <div>
          <Label className="text-sm text-muted-foreground mb-1 block">Fecha de nacimiento *</Label>
          <Input
            type="date"
            value={form.date_of_birth || ""}
            onChange={(e) => setForm((f) => ({ ...f, date_of_birth: e.target.value }))}
            data-testid={testIds.dob}
          />
        </div>
      )}
      {requiredFields.includes("emergency_contact") && (
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Contacto de emergencia *</Label>
            <Input
              value={form.emergency_contact_name || ""}
              onChange={(e) => setForm((f) => ({ ...f, emergency_contact_name: e.target.value }))}
              placeholder="Nombre"
              data-testid={testIds.emergencyName}
            />
          </div>
          <div>
            <Label className="text-sm text-muted-foreground mb-1 block">Telefono de emergencia *</Label>
            <Input
              value={form.emergency_contact_phone || ""}
              onChange={(e) => setForm((f) => ({ ...f, emergency_contact_phone: e.target.value }))}
              data-testid={testIds.emergencyPhone}
            />
          </div>
        </div>
      )}
      {requiredFields.includes("allergies") && (
        <div>
          <Label className="text-sm text-muted-foreground mb-1 block">Alergias / observaciones médicas *</Label>
          <Textarea
            value={form.allergies || ""}
            onChange={(e) => setForm((f) => ({ ...f, allergies: e.target.value }))}
            placeholder="Escribi 'Ninguna' si no tiene"
            rows={2}
            data-testid={testIds.allergies}
          />
        </div>
      )}
    </>
  );
}
